<ng-container *transloco="let t">

  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1 *ngIf="order === null">{{ t("common.labels.freeorder") }}</h1>
      <h1 *ngIf="order !== null">
        <span>
          <strong>{{ order.name }}</strong><br>
          <i class="subline">
            {{ t('common.labels.ordernumber') }}: <strong>{{ order.ordernumber }}</strong> / {{ t('common.labels.status') }}: <strong>{{ t('common.labels.' + order.status) }} <ng-container *ngIf="order.status === 'cancelled' && order.cancelled_at">{{ t('common.labels.on') }} {{ order.cancelled_at | amLocal | amDateFormat: 'DD.MM.YYYY' }}</ng-container></strong>
            <span *ngIf="order.cancellation_reason"> / {{ t('common.labels.cancellation_reason') }}: <strong>{{ t('common.labels.' + order.cancellation_reason) }}</strong></span>
          </i>
        </span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

        <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
          <app-order-detail-basedata
            [(order)]="order"
            [mode]="viewMode"
            [options]="options"
            [templates]="templates"
            [texts]="texts"
            [user]="user"
            [backRoute]="backRoute"
            (cancelled)="onClose()"
            (setEdit)="setEdit($event)"
            (setClearingUrl)="setClearingUrl($event)"
          ></app-order-detail-basedata>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.exercises') }}" leftIcon="pi pi-briefcase" [disabled]="isDisabled('exercises') || order === null">
          <app-ac-exercises *ngIf="editMode()" [(ac)]="order" (setEdit)="setEdit($event)"></app-ac-exercises>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.onlinetests') }}" leftIcon="pi pi-inbox" [disabled]="isDisabled('onlinetests') || order === null">
          <app-ac-onlinetests *ngIf="editMode()" [ac]="order" [partners]="partners" (setEdit)="setEdit($event)"></app-ac-onlinetests>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.time_schedule') }}" leftIcon="pi pi-clock" [disabled]="isDisabled('timing') || order === null">
          <app-ac-timing *ngIf="editMode()" [ac]="order" (setEdit)="setEdit($event)"></app-ac-timing>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.files') }}" leftIcon="pi pi-copy" [disabled]="isDisabled('files') || !auth.canSeeFiles() || order === null">
          <app-ac-files *ngIf="editMode() && auth.canSeeFiles()" [ac]="order" (setEdit)="setEdit($event)"></app-ac-files>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.todos') }}" leftIcon="pi pi-list" [disabled]="isDisabled('todos') || order === null">
          <app-order-detail-todos *ngIf="editMode()" [(order)]="order" (setEdit)="setEdit($event)"></app-order-detail-todos>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.log') }}" leftIcon="pi pi-book" [disabled]="isDisabled('log') || order === null">
          <app-order-detail-log
            [order]="order"
          ></app-order-detail-log>
        </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>

</ng-container>
